import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import OtpInput from '@bachdgvn/vue-otp-input'
import JobService from '../../services/jobService'
import UserService from '../../services/UserService'
import { showSuccessToast, showErrorToast } from '../../services/UI'
import GuestService from '../../services/GuestService'

Vue.component('v-otp-input', OtpInput)
export default {
  name: 'earningsModal',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      mutableActived: this.activated,
      applicationData: [],
      user: '',
      nId: '',
      currApplicationId: '',
      departments: [],
      specialisation: [],
      hover: false,
      jobData: [],
      selected: '',
      active_el: null

    }
  },
  async created () {
    this.departments = await UserService.listDepartment()
    this.specialisations = await GuestService.listSpecialisations()
  },
  props: ['activated', 'closeEarningsModal', 'id', 'jobApplicantsRatio'],
  methods: {
    activate: function (el) {
      this.active_el = el
    },
    handleFileChange (e) {
      this.$emit('input', e.target.files[0])
    },
    closeReviewJobModal () {
      this.closeEarningsModal(true)
      this.mutableActived = !this.mutableActived
      this.$el.blur()
      this.user = ''
      this.applicationData = []
    },
    async getApplicationDetails () {
      // console.log(this.id)
      this.applicationData = await JobService.openJobDetails(this.id)
      // console.log('sss', this.applicationData)
      this.jobData = await JobService.getJobById(this.id)
      // console.log(this.jobData)
      this.user = this.applicationData[0].professional
      // console.log(this.user)
      this.currApplicationId = this.applicationData[0].id
      // console.log(this.user)
    },
    getDate (data) {
      const date = parseInt(data)
      const res = Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).format(new Date(date))
      return res
    },
    async getUserData (id, applicationId, el) {
      // console.log(id)
      this.active_el = el
      this.user = await UserService.getUserbyId(id)
      this.currApplicationId = applicationId
      console.log(this.user)
    },
    async approveSelectedApplication (applicationId) {
      const applicationDetails = await JobService.getApplicationDetails(applicationId)
      if (applicationDetails.state === 'ACCEPTED' || applicationDetails.state === 'REJECTED' || applicationDetails.state === 'WITHDRAW') {
        return showErrorToast(this, 'Cannot change application status')
      }
      const response = await JobService.approveApplication(applicationId)
      if (response) {
        showSuccessToast(this, 'Application Approved')
        this.getApplicationDetails()
      } else {
        showErrorToast(this, 'Application Not Approved')
      }
    },
    async shortListApplication (applicationId) {
      const applicationDetails = await JobService.getApplicationDetails(applicationId)
      if (applicationDetails.state === 'ACCEPTED' || applicationDetails.state === 'REJECTED' || applicationDetails.state === 'WITHDRAW') {
        return showErrorToast(this, 'Cannot change application status')
      }
      const response = await JobService.shortList(applicationId)
      if (response) {
        showSuccessToast(this, 'Application Shortlisted for 2nd Round')
        this.getApplicationDetails()
      } else {
        showErrorToast(this, 'Error Shortlisting')
      }
    },
    async rejectApplication (applicationId) {
      const applicationDetails = await JobService.getApplicationDetails(applicationId)
      if (applicationDetails.state === 'ACCEPTED' || applicationDetails.state === 'REJECTED' || applicationDetails.state === 'WITHDRAW') {
        return showErrorToast(this, 'Cannot change application status')
      }
      const response = await JobService.cancelMiniJobApplication(applicationId)
      if (response) {
        showSuccessToast(this, 'Application Rejected')
        this.getApplicationDetails()
      } else {
        showErrorToast(this, 'Error Rejecting Application')
      }
    },
    getDateFromTime (time) {
      const convertedDate = new Date(Number(time))

      const res = Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).format(new Date(convertedDate))
      return res
    },
    getDepartmentById (id) {
      const department = this.departments.filter((item) => {
        if (item.departmentType.id === id) {
          return item
        }
      })
      return department[0] && department[0].departmentType.name
    },
    getSpecialisationById (id) {
      const name = this.specialisations.filter((item) => {
        if (item.id === id) {
          return item.name
        }
      })
      return (name[0].name)
    },
    async filterStatus (e) {
      this.applicationData = await JobService.openJobDetails(this.id)
      // console.log(e.target.value)
      const filterArr = this.applicationData.filter((item) => {
        // console.log(item.state, e.target.value)
        return item.state === e.target.value
      })
      this.applicationData = filterArr
    },
    reset () {
      this.selected = ''
      this.getApplicationDetails()
    }
  },
  watch: {
    activated (oldVal, newVal) {
      if (oldVal !== newVal && oldVal !== null) {
        this.mutableActived = !this.mutableActived
        this.$el.tabIndex = 1
        this.$nextTick(function () {
          this.$el.focus()
        })
      }
      this.getApplicationDetails()
    }
  }
}
